exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cardFooter[data-v-32e63be2] {\n\tdisplay: inline-block;\n\tfont-weight: 700;\n\tcolor: #fff;\n\tbackground-color: #00a09c;\n\tborder-color: #00a09c;\n\ttext-align: center;\n\tvertical-align: middle;\n\tuser-select: none;\n\tpadding: 0.375rem 0.75rem;\n\tfont-size: 1rem;\n\tline-height: 1.5;\n}\n.error[data-v-32e63be2] {\n\tcolor: red;\n}\n.cardTextBody[data-v-32e63be2] {\n\tmin-height: 230px;\n}\n.imgHeight[data-v-32e63be2] {\n\theight: 165px;\n\tobject-fit: contain;\n}\n", ""]);

// exports
